import { Injectable }                         from '@angular/core';
import { Title }                              from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService }                   from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class AppTitleStrategy extends TitleStrategy {
    private readonly base = 'Bochum Rebels e.V.';
    private lastKey: string | undefined;

    constructor(
        private readonly title: Title,
        private readonly translateService: TranslateService,
    ) {
        super();
        translateService.onLangChange.subscribe(() => this.applyTitle());
        translateService.onTranslationChange.subscribe(() => this.applyTitle());
    }

    override updateTitle(state: RouterStateSnapshot): void {
        this.lastKey = this.buildTitle(state);
        this.applyTitle();
    }

    private applyTitle(): void {
        if (this.lastKey) {
            const translated = this.translateService.instant(this.lastKey);
            this.title.setTitle(`${this.base} | ${translated}`);
        } else {
            this.title.setTitle(this.base);
        }
    }
}
